import { Droplet, Layers, Crown, Globe, Gem, MessageCircle, Megaphone, BookOpen, Award, Repeat, Star } from "lucide-react";

const ICONMAP = {
  droplet: Droplet, layers: Layers, crown: Crown, globe: Globe, gem: Gem,
  "message-circle": MessageCircle, megaphone: Megaphone, "book-plus": BookOpen,
  award: Award, repeat: Repeat, star: Star,
};

export function Badges({ badges }) {
  if (!badges?.length) return null;
  const earnedCount = badges.filter((b) => b.earned).length;
  return (
    <div data-testid="badges-section">
      <div className="flex items-center gap-2 mb-3">
        <Award className="w-5 h-5 brand-text" />
        <h2 className="font-display text-2xl font-bold">Awards</h2>
        <span className="ml-1 text-sm font-tech text-muted-page">{earnedCount}/{badges.length} earned</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="badges-grid">
        {badges.map((b) => {
          const Icon = ICONMAP[b.icon] || Award;
          return (
            <div
              key={b.id}
              data-testid={`badge-${b.id}`}
              className={`rounded-xl border p-4 flex items-center gap-3 transition-all ${b.earned ? "border-2" : "opacity-45 grayscale"}`}
              style={b.earned ? { borderColor: "var(--honey-500)", background: "var(--honey-100)" } : { borderColor: "var(--page-border)" }}
            >
              <div className="w-11 h-11 rounded-lg grid place-items-center shrink-0" style={{ background: b.earned ? "var(--honey-500)" : "var(--page-border)", color: "#3a2a10" }}>
                <Icon className="w-5 h-5" />
              </div>
              <div className="min-w-0">
                <p className="font-display font-bold leading-tight">{b.label}</p>
                <p className="text-xs text-muted-page">{b.desc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
